import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOther = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#949ba7",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Other",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group 10",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "Group 8",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Rectangle 16667",
						d: "M3 2H6C6.55228 2 7 2.44772 7 3V6C7 6.55228 6.55228 7 6 7H3C2.44772 7 2 6.55228 2 6V3C2 2.44772 2.44772 2 3 2Z",
						fill: "currentColor",
						fillOpacity: .25,
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Rectangle 16668",
						d: "M10 2H13C13.5523 2 14 2.44772 14 3V6C14 6.55228 13.5523 7 13 7H10C9.44772 7 9 6.55228 9 6V3C9 2.44772 9.44772 2 10 2Z",
						fill: "currentColor",
						fillOpacity: .25,
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})]
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group 9",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Rectangle 16667_2",
						d: "M3 9H6C6.55228 9 7 9.44772 7 10V13C7 13.5523 6.55228 14 6 14H3C2.44772 14 2 13.5523 2 13V10C2 9.44772 2.44772 9 3 9Z",
						fill: "currentColor",
						fillOpacity: .25,
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Rectangle 16668_2",
						d: "M10 9H13C13.5523 9 14 9.44772 14 10V13C14 13.5523 13.5523 14 13 14H10C9.44772 14 9 13.5523 9 13V10C9 9.44772 9.44772 9 10 9Z",
						fill: "currentColor",
						fillOpacity: .25,
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})]
				})]
			})
		})
	})
});
export default SvgOther;
